export default "__VITE_ASSET__Bml6$$ap__"